import React, { useState } from 'react'; // Added useState import
import { useDispatch, useSelector } from 'react-redux';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import DocumentFormView from "./DocumentFormView";
import TimezoneClock from '../../../components/common/TimeZone';
import './index.scss';
import moment from "moment";
import DocumentLog from './DocumentLog'
import RulesIcon from "../../../assets/img/icons/updated-file.svg"

const DocumentView = ({ fileData, page, userName }) => {
	const [activeTab, setActiveTab] = useState("1"); // Added state for active tab
	const dispatch = useDispatch();

	const toggleTab = (tab) => { // Added function to toggle tabs
		if (activeTab !== tab) setActiveTab(tab);
	};

	const userDetail = useSelector((state) => state?.user?.user);
	const isAdminLoggedIn = useSelector(state => state?.user?.user?.isAdminLoggedIn)

	return (
		<>
			<div className={`document-view-blc d-flex flex-fill overflow-auto`} >
				<div className="left-col d-flex flex-fill flex-column overflow-auto position-relative">
					<Nav tabs>
						<div className={`left-col d-flex flex-wrap`}>
							<NavItem>
								<NavLink onClick={() => toggleTab("1")} active={activeTab === "1"}> {/* Updated to handle click */}
									Document
								</NavLink>
							</NavItem>
							<NavItem>
								<NavLink onClick={() => toggleTab("2")} active={activeTab === "2"}> {/* Updated to handle click */}
									Audit Log
								</NavLink>
							</NavItem>
						</div>
						<div className="right-col responsive-menu-btn ms-auto d-flex align-items-center">
							{activeTab == "1" &&

								<div
									style={{ marginRight: "13px", cursor: "pointer", position: "relative" }}
									onClick={() => {
										// Check if the docAssist window is already open
										if (window.docAssistWindow && !window.docAssistWindow.closed) {
											// Bring the existing window into focus
											window.docAssistWindow.focus();
											return;
										}

										const documentTypeId = fileData?.packet_type?._id;
										const organizationId = fileData?.organization;
										const width = window.innerWidth * 0.5;
										const height = window.innerHeight * 0.8;
										const gap = 20;
										const left = window.innerWidth - width - gap;
										const top = window.innerHeight - height + 2 * gap;

										// Open a new window with a fixed target name
										window.docAssistWindow = window.open(
											`/docAssistRules?packetId=${'dennis'}&orgId=${organizationId}`,
											"docAssistRules", // fixed window name so that it reuses the same window
											`width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
										);

										// Update your Redux or local state accordingly
										dispatch({ type: "OPENED_TAB", data: [window.docAssistWindow] });
										// setOpenedWindow([window.docAssistWindow]);
									}}

									title="View Rules"
								>
									<img src={RulesIcon} alt="Rules Icon" style={{ width: '25px', height: '25px' }} />
								</div>
							}
						</div>
					</Nav>
					<TabContent activeTab={activeTab} className={`flex-fill overflow-auto active`}> {/* Updated activeTab */}
						{activeTab == 1 ? <TabPane tabId="1" className='ocr-tabPane'>
							<div className="file-version-blc d-inline-flex align-items-center text-start" id='getWidth'>
								<div className="left-col">
									<a href="#" className='lbl'>
										{fileData?.folder?.loan_number}
									</a>
									<span className="arrow-icon">
										&raquo;
									</span>
									<label className='des'>
										{fileData?.name}
									</label>
								</div>
								<div className="right-col ms-auto">
									<label>
										<span>
											{fileData?.reviewLabeled ? 'Indexed By:' : fileData?.complete ? 'Completed By:' : 'By:'}

										</span>
										{fileData?.reviewLabeled ? fileData?.reviewLabeledByUser ? fileData?.reviewLabeledByUser?.fname + " " + fileData?.reviewLabeledByUser?.lname : fileData?.reviewLabeledByAdmin?.fname + " " + fileData?.reviewLabeledByAdmin?.lname : fileData?.complete ? fileData?.completedByUser ? fileData?.completedByUser?.fname + " " + fileData?.completedByUser?.lname : fileData?.completedByAdmin?.fname + " " + fileData?.completedByAdmin?.lname : userName}
									</label>
									<label>
										<span>
											On:
										</span>
										{(userDetail?.timezone) ? <><TimezoneClock timezone={userDetail?.timezone} dateTime={fileData?.updatedAt} timeFormat={"MMM DD,YYYY"} /> at <TimezoneClock timezone={userDetail?.timezone} dateTime={fileData?.updatedAt} timeFormat={"h:mm a"} /></> : moment(fileData?.updatedAt).format(
											"MMM DD,YYYY"
										) + ' at ' + moment(fileData?.updatedAt).format(
											"h:mm a"
										)}
									</label>
								</div>
							</div>
							<DocumentFormView fileData={fileData} page_no={page} />
						</TabPane> : null}

						{activeTab == 2 ? <TabPane tabId="2" className='ocr-tabPane'>
							<DocumentLog fileData={fileData} />
						</TabPane> : null}
					</TabContent>
				</div>

			</div>
		</>
	);
}

export default DocumentView;